import React from "react";
import RIcon from "./ReservasIcons";

/** Opt-in to news and promotions. Unchecked by default; the flows only send `marketingOptIn: true` when checked. */
const MarketingOptIn = ({ venueName, checked, onChange }) => {
  const toggle = () => onChange((c) => !c);
  return (
    <div
      className="consent"
      style={{ marginTop: 10 }}
      role="checkbox"
      aria-checked={checked}
      tabIndex={0}
      onClick={toggle}
      onKeyDown={(e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          toggle();
        }
      }}
    >
      <span className={`cbox${checked ? " on" : ""}`}>{checked && <RIcon name="check" width={13} height={13} />}</span>
      <p>Acepto recibir novedades y promociones de {venueName || "este local"}</p>
    </div>
  );
};

export default MarketingOptIn;
